import * as z from "zod";

export const cancelAccountingConnection = {
  name: "cancelAccountingConnection" as const,
  input: z.object({ connectionId: z.bigint() }),
  output: z.object({ success: z.boolean() }),
};
